export default __webpack_public_path__ + "static/media/Sportswear.c91bbe19.png";